export default {
  menu: [
    { icon: 'mdi-home', title: 'Dashboard', link: { name: 'ambienteAluno.dashboard' } },
    { icon: 'mdi-folder', title: 'Cursos', link: { name: 'ambienteAluno.course.index' } }
  ],
  menuProfile: [
    { icon: 'mdi-account', title: 'Perfil', link: { name: 'ambienteAluno.perfil' } },
    { icon: 'mdi-lock', title: 'Alterar Senha', link: { name: 'ambienteAluno.alterarSenha' } },
    { icon: 'mdi-arrow-left', title: 'Sair', link: { name: 'auth.logout' } }
  ]
}
